import mitt from 'mitt'
import type { ToastEmitterContract, ToastItem } from '@mobi/component-library/Feedback/Toast/types'

export const globalToastEmitter = mitt<ToastEmitterContract>()

export const addToast = (toast: ToastItem) => globalToastEmitter.emit('addToast', toast)
export const removeToast = (id: Pick<ToastItem, 'id'>) => globalToastEmitter.emit('removeToast', id)

/** Used to create new context for toasts, allowing render relative to parent */
export const createToastsEventEmitter = () => mitt<ToastEmitterContract>()
